import React , { useState , useEffect } from 'react'
import Container from '@mui/material/Container';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';
import Box from '@mui/material/Box';
// ventana de Dialogo
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
//
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function CentrosTodos() {
  //const [loading, setLoading] = useState(true);
  const [seleccionados, setSeleccionados] = useState(false);
  
  const [comercios,setComercios] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [openNuevo, setOpenNuevo] = React.useState(false);
  const [openEstado, setOpenEstado] = React.useState(false);
  const [estado, setEstado] = React.useState(false);
  const [openMsgOk, setOpenMsgOk] = React.useState(false);
  const [openMsgError, setOpenMsgError] = React.useState(false);
  const [mensaje, setMensaje] = React.useState('');
  const [titulo, setTitulo] = React.useState('');

  const [id, setId] = React.useState(0);
  const [rz, setRz] = React.useState('');
  const [detalle, setDetalle] = React.useState('');
  // para los autocompplete
  const [provincias,setProvincias] = useState([]);
  const [localidades,setLocalidades] = useState([]);
  const [selectedOptionProvincia, setSelectedOptionProvincia] = useState(null);
  const [selectedOptionLocalidad, setSelectedOptionLocalidad] = useState(null);  

  const getCentroscomerciales = (valor) => {
    //setLoading(true);
    const baseURL = process.env.REACT_APP_SERVER_PATH+'getCentrosComerciales/'+selectedOptionProvincia+'/'+valor;
    fetch(`${baseURL}`)
     .then(res => res.json())
    .then(
      (result) => {
      setComercios(result);
      //setLoading(false);
      },
      (error) => {
      }
    )
   }

   const getProvincias = () => {
    const baseURL = process.env.REACT_APP_SERVER_PATH  + 'getProvincias';
    fetch(`${baseURL}`)
    .then(res => res.json())
    .then(
      (result) => { setProvincias(result) 
      },
      (error) => {
      }
    )
   }

   const getLocalidades = (selected) => {
    const baseURL = process.env.REACT_APP_SERVER_PATH  + 'getLocalidades/'+selected;
    fetch(`${baseURL}`)
    .then(res => res.json())
    .then(
      (result) => { setLocalidades(result) 
      },
      (error) => {
      }
    )
   }

  const handleOptionChangeLocalidades = (event , value) => {

    if (value !== null) {
      setSelectedOptionLocalidad(value.localidad);
      getCentroscomerciales(value.localidad); 
      if (selectedOptionProvincia !== null && selectedOptionLocalidad !== null)
          {setSeleccionados(true)}
      else
          {setSeleccionados(false)}
    }
    else
    {setSeleccionados(false)}

  }

  const handleOptionChangeProvincias = (event, value) => {
    setSelectedOptionProvincia(value.provincia);
    // cambio las localidad segun la provincia selecconada
    getLocalidades(value.provincia);
    // cambio las localidad segun la provincia selecconada
    if (value != null) {
       setSelectedOptionProvincia(value.provincia);
       setLocalidades(localidades);

    }
    else {
      setLocalidades([]);
        }
  }

   const handleDeleteClick = async (id,rz) => {
      setId(id);
      setRz(rz);
      setOpen(true);
    };

    const handleEstadoClick = async (id,rz,titulo) => {
    // ventana modificacion  
      if (titulo === 'Aprueba') {
          setEstado(true);
        }
      else
          {setEstado(false);} 

      setId(id);
      setRz(rz);
      setDetalle(rz);
      setTitulo(titulo);
      setOpenEstado(true);
    };     

   const handleDelete = async() => {
    try {
      const baseURL = process.env.REACT_APP_SERVER_PATH + 'deleteCentroComercial/'+id;
      const res = await fetch(`${baseURL}`, {
        method: "delete",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": "token-value",
          'Access-Control-Allow-Origin': '*'
        }
      });
      setOpen(false); // cierra ventana para todos los casos
      if (( res.status === 200 ) || ( res.status === 204 ) || ( res.status === 304 )) {
        getCentroscomerciales(selectedOptionLocalidad); 
        
         setMensaje('Eliminación Correcta');
         handleClickMsg();
            }
      else
          if ( res.status === 505 ) {
            setMensaje('NO se puede eliminar, existen COMERCIOS con este Centro');
            setOpenMsgError(true);
              console.log('Error al eliminar el comercio!');
              } 
          else    
              { 
                setMensaje('Error al eliminar');
                setOpenMsgError(true);}
          } catch (err) {
            console.log(err.message)
          }
  };
  // modificacion 
  const handleSubmit = async(event) => {
    event.preventDefault();
    setEstado(true);
    setOpen(false);
      const postData = {
        descripcion : detalle,
        idcentrocomercial : id
    };
    try {
      const baseURL = process.env.REACT_APP_SERVER_PATH + 'updateCentroComercial';
      const res = await fetch(`${baseURL}`, {
        method: "put",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": "token-value",
          'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify(postData),
      });
     
      if (( res.status === 200 ) || ( res.status === 204 ) || ( res.status === 304 )) {
          setOpenEstado(false);
          setDetalle('');
          
          getCentroscomerciales(selectedOptionLocalidad); 
          setMensaje('Modificación Correcta');
          handleClickMsg();

          }
      else
          if ( res.status === 500 ) {
             setMensaje('Error al modificar');
             setOpenMsgError(true);
             console.log('Error al eliminar el comercio!');
              } 
          else    
              { 
                setMensaje('Error al eliminar');
                setOpenMsgError(true);}
          } catch (err) {
            console.log(err.message)
          }
  };

  const handleNuevoSubmit = async(event) => {


    event.preventDefault();
    setEstado(true);
    setOpenNuevo(false);
      const postData = {
        descripcion : detalle,
        provincia : selectedOptionProvincia,
        localidad: selectedOptionLocalidad,

    };
    try {
      const baseURL = process.env.REACT_APP_SERVER_PATH + 'addCentroComercial';
      const res = await fetch(`${baseURL}`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": "token-value",
          'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify(postData),
      });
     
      if (( res.status === 200 ) || ( res.status === 204 ) ) {
        setOpenNuevo(false);
          setDetalle('');
          
          getCentroscomerciales(selectedOptionLocalidad); 
          setMensaje('Modificación Correcta');
          //handleClickMsg();

          }
      else
          if ( res.status === 500 ) {
             setMensaje('Error al Crear');
             setOpenMsgError(true);
             console.log('Error al eliminar el comercio!');
              } 
          else    
              { 
                setMensaje('Error al eliminar');
                setOpenMsgError(true);}
          } catch (err) {
            console.log(err.message)
          }
  };

  const handleNuevoClose = () => {
    setOpenNuevo(false);
  };

  const handleClose = () => {
    setOpen(false);
  };
  //
  const handleEstadoClose = () => {
    setOpenEstado(false);
  };

  const handleClickMsg = () => {
    setOpenMsgOk(true);
  };

  const handleCloseMsg = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenMsgOk(false);
  };
  //
  const handleClickMsgError = () => {
    setOpenMsgError(true);
  };

  const handleCloseMsgError = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenMsgError(false);
  };
const control = () => {
  if (selectedOptionProvincia == null || selectedOptionLocalidad == null)
      {alert('Complete Provincia y Localidad')}
  else
      {setOpenNuevo(true)}    

}
   useEffect(() => {

      getProvincias();
},[])
  
  return (<>
      {/* VENTANA NUEVO */}
      <Dialog
        open={openNuevo}
        onClose={handleNuevoClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description-estado"
      >
         <Box component="form" onSubmit={handleNuevoSubmit} sx={{ mt: 3 }}>
        <DialogTitle id="alert-dialog-title">
          {"Ingrese descripción del nuevo Centro Comercial"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description-estado">
          </DialogContentText>
          <TextField 
              id="standard-basic" 
              label="Descripción" 
              variant="standard" 
              value = {detalle}
              onChange = {(e) => setDetalle(e.target.value)}
              required
              sx={{ mt: 2, mb: 2 }}/>
              
        </DialogContent>
        <DialogActions>
          <Button type = "submit" color ="primary" variant = "contained" onClick={handleClose}>Aceptar</Button>
          <Button color ="secondary" variant = "contained" onClick={handleNuevoClose} autoFocus>
            Cancelar
          </Button>
        </DialogActions>
        </Box>
      </Dialog>

      {/* VENTANA MODIFICACION */}
      <Dialog
        open={openEstado}
        onClose={handleEstadoClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description-estado"
      >
         <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
        <DialogTitle id="alert-dialog-title">
          {"¿"+titulo+" al Centro: "+rz+"?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description-estado">
           
          </DialogContentText>
         
          <TextField 
              id="standard-basic" 
              label="Descripción" 
              variant="standard" 
              value = {detalle}
              onChange = {(e) => setDetalle(e.target.value)}
              required
              sx={{ mt: 2, mb: 2 }}/>
              
        </DialogContent>
        <DialogActions>
          <Button type = "submit" color ="primary" variant = "contained" onClick={handleClose}>Aceptar</Button>
          <Button color ="secondary" variant = "contained" onClick={handleEstadoClose} autoFocus>
            Cancelar
          </Button>
        </DialogActions>
        </Box>
      </Dialog>
    {/* VENTANA DE ELIMINACION */}
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'¿Confirma ELIMINAR al Centro comercial: '+rz+'?'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Esta acción no se puede revertir
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="contained" onClick={handleDelete}>Aceptar</Button>
          <Button color="secondary" variant="contained" onClick={handleClose} autoFocus>
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    <Container component="main" maxWidth="lg">
     <h2>Centros Comerciales</h2>

             <Grid item xs={6} >
       <Autocomplete sx = {{mt : 2}}
                      id="auto"
                      options={provincias}
                      getOptionLabel={(provincias) => provincias.provincia}
                      renderInput={(params) => <TextField {...params} label="Provincia" variant="outlined" />}
                      onChange={handleOptionChangeProvincias}
                      />
      </Grid>
      <Grid item xs={6} >
          <Autocomplete sx = {{mt : 2}}
                  id="auto"
                  options={localidades}
                  getOptionLabel={(localidades) => localidades.localidad}
                  renderInput={(params) => <TextField {...params} label="Localidad" variant="outlined" />}
                  onChange={handleOptionChangeLocalidades}
                  />   
                   </Grid>
                   <Button
              type="submit"
          
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick = {()=>control()}
            > Nuevo</Button> 
                   {seleccionados ? (   <div> 


        <TableContainer component={Paper}  sx = {{mt : 2}}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        < TableHead>
          <TableRow>
            <TableCell >ID</TableCell >
            <TableCell >Descripción</TableCell >

            <TableCell ></TableCell >
            <TableCell >Acciones</TableCell >
          </TableRow>
        </ TableHead>
        <TableBody>
        {comercios.map((item) => (
            <TableRow
              key={item.idcentrocomercial}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell >{item.idcentrocomercial}</TableCell >
              <TableCell >{item.descripcion}</TableCell >

              <TableCell >
              <Button color="primary" variant="outlined" startIcon={<CheckIcon />} 
              onClick={() => handleEstadoClick(item.idcentrocomercial,item.descripcion,"Modifica")}>Editar</Button>
              </TableCell >

              <TableCell >
                <Button color="error" variant="outlined" startIcon={<DeleteIcon />} 
                onClick={() => handleDeleteClick(item.idcentrocomercial,item.descripcion)}>Eliminar</Button>
              </TableCell >
              </TableRow>
          ))}          
        </TableBody>
      </Table>
      </TableContainer>
      </div>   ):(<div></div>)}
       
     
      <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar open={openMsgOk} autoHideDuration={6000} onClose={handleCloseMsg}>
        <Alert onClose={handleCloseMsg} severity="success" sx={{ width: '100%' }}>
          {mensaje}
        </Alert>
      </Snackbar>
    </Stack>

    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar open={openMsgError} autoHideDuration={6000} onClose={handleCloseMsgError}>
        <Alert onClose={handleCloseMsgError} severity="error" sx={{ width: '100%' }}>
        {mensaje}
        </Alert>
      </Snackbar>
    </Stack>

    </Container>
   </> )
}

export default CentrosTodos